<div class="row space-between">
    <h2>Convert Figma Site to Closing</h2>
    <rr-icon name="close" class="pointer"></rr-icon>
</div>
@if(!responseJson){
<div class="col gap-16">
    <rr-input label="Name" [(ngModel)]="name"></rr-input>
    <rr-input label="URL to export" type="url" [(ngModel)]="url"></rr-input>
</div>
<div class="row gap-8 justify-end">
    <rr-btn type="Secondary" (click)="close()">Cancel</rr-btn>
    <rr-btn type="Primary" (click)="startextraction()">Start Export</rr-btn>
</div>
} @if(responseJson){
<pre>{{ responseJson | json }}</pre>
<div class="row gap-8 justify-end">
    <rr-btn type="Secondary" (click)="close()">Close</rr-btn>
</div>
} @if(isLodaing === true){
<rr-spinner></rr-spinner>

}
